export default class Domain {
    static isDomestic() {
        return CBS.Registry.region.property === 'US';
    }

    static isInternational() {
        return !this.isDomestic();
    }

    static getRegionCode() {
        return CBS.Registry.region.property.toLowerCase();
    }
}
